import { ModelConfig } from '@type/chat';

import { DEFAULT_TOKEN_CONFIG } from '../tokens/TokenConfig';

export type { ModelConfig } from '@type/chat';

export const DEFAULT_MODEL_CONFIG: ModelConfig = {
  model: 'claude-sonnet-4-6',
  max_tokens: DEFAULT_TOKEN_CONFIG.max_tokens,
  temperature: 0.7,
  top_p: 1,
  presence_penalty: 0,
  frequency_penalty: 0,
  thinking: {
    enabled: false,
    budget_tokens: DEFAULT_TOKEN_CONFIG.thinking.budget_tokens,
  },
  thinking_mode: {
    enabled: false,
    budget_tokens: DEFAULT_TOKEN_CONFIG.thinking.budget_tokens
  },
};